import React from 'react';
import { Container, Media } from '../../components';
import { HeaderModuleMobile } from './mobile';
import { HeaderModuleTablet } from './tablet';
import { HeaderModuleDesktop } from './desktop';
import styled from 'styled-components';

const DesktopWrapper = styled.section`
  background-color: #faf2f4;
`;

export const HeaderModule = (props) => {
  return (
    <>
      <DesktopWrapper>
        <Media greaterThanOrEqual="xmd">
          <HeaderModuleDesktop {...props} />
        </Media>
      </DesktopWrapper>
      <Container>
        <Media at="md">
          <HeaderModuleTablet {...props} />
        </Media>
      </Container>
      <Container>
        <Media at="sm">
          <HeaderModuleMobile {...props} />
        </Media>
      </Container>
    </>
  );
};
